import { useMemo } from 'react';
import { Table2 } from 'lucide-react';
import { parseSetupSql, type ParsedTable } from '@/lib/parseSetupSql';

/**
 * Namuna setup SQL ini jadval ko'rinishida ko'rsatadi.
 * Parse qilib bo'lmasa — xom SQL ga qaytadi (ma'lumot yo'qolmasligi uchun).
 */
export function SampleTables({ setupSql }: { setupSql: string }) {
  const tables = useMemo(() => parseSetupSql(setupSql), [setupSql]);

  if (tables.length === 0) {
    return <SqlBlock sql={setupSql} />;
  }

  return (
    <div className="space-y-3">
      {tables.map((table) => (
        <DataTable key={table.name} table={table} />
      ))}
    </div>
  );
}

function DataTable({ table }: { table: ParsedTable }) {
  return (
    <div className="overflow-hidden rounded-DEFAULT border border-line">
      <div className="flex items-center gap-2 border-b border-line bg-surface px-3 py-2">
        <Table2 className="h-4 w-4 text-[var(--brand-secondary)]" />
        <span className="font-mono text-sm font-semibold">{table.name}</span>
      </div>

      <div className="overflow-x-auto">
        <table className="result-table">
          <thead>
            <tr>
              {table.columns.map((col) => (
                <th key={col.name}>
                  <span className="block">{col.name}</span>
                  <span className="block font-normal normal-case text-content-muted">{col.type}</span>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {table.rows.map((row, ri) => (
              <tr key={ri}>
                {row.map((cell, ci) => (
                  <td key={ci}>
                    {cell === null ? (
                      <span className="italic text-content-muted">NULL</span>
                    ) : (
                      String(cell)
                    )}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function SqlBlock({ sql }: { sql: string }) {
  return (
    <pre className="overflow-x-auto rounded-DEFAULT bg-[#0d1117] p-3 font-mono text-[0.8125rem] leading-relaxed text-slate-200">
      {sql.trim()}
    </pre>
  );
}
